import { RequestStatusWithData } from '@customTypes/api/api.types';

export enum REQUEST_PATH {
    LOCATE_PRODUCT = '/ManageInventory/LocateProduct'
}

export interface LocateProductlDTO {
    AccountNum: string;
    SubAccountNum: string;
    ClientItemIds: string[];
    Ssls: string[];
}

interface LocateProductResponseData {
    ssls: LocateProductWarehouse[];
}

interface LocateProductWarehouse {
    code: string;
    city?: string;
    country?: string;
    countryCode?: string;
    province?: string;
    parts: LocateProductPart[];
}

export interface LocateProductPart {
    clientItemId: string;
    goodProductQty: number;
    badProductQty: number;
    serialList: LocateProductSerial[];
    substituteItemList: LocateProductSubstituteItem[];
}

export interface LocateProductSerial {
    condition: string;
    clientSerial: string;
    countryOfManufacture?: string;
    revisionLevel?: string;
    refurbished: boolean;
}

interface LocateProductSubstituteItem {
    clientSubstituteItemId: string;
}

export type LocateProductResponse =
    RequestStatusWithData<LocateProductResponseData>;
